module.exports = __webpack_public_path__ + "img/loader.84ce1239.svg";